import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { LANGUAGES, translations } from "@/i18n/translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem("keepflow-lang");
    if (saved && translations[saved]) return saved;
    const nav = navigator.language?.slice(0, 2);
    return translations[nav] ? nav : "en";
  });

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    localStorage.setItem("keepflow-lang", code);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback(
    (path, vars) => {
      const dict = translations[lang] || translations.en;
      const parts = path.split(".");
      let v = dict;
      for (const p of parts) v = v?.[p];
      if (v === undefined) {
        // fallback to English
        let f = translations.en;
        for (const p of parts) f = f?.[p];
        v = f;
      }
      if (typeof v !== "string") return path;
      if (vars) {
        return v.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ""));
      }
      return v;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useT = () => useContext(LanguageContext);
